var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20,
    fill: "#C7F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 28.5C11.95 28.5 11.4793 28.3043 11.088 27.913C10.6967 27.5217 10.5007 27.0507 10.5 26.5V14.5C10.5 13.95 10.696 13.4793 11.088 13.088C11.48 12.6967 11.9507 12.5007 12.5 12.5H28.5C29.05 12.5 29.521 12.696 29.913 13.088C30.305 13.48 30.5007 13.9507 30.5 14.5V26.5C30.5 27.05 30.3043 27.521 29.913 27.913C29.5217 28.305 29.0507 28.5007 28.5 28.5H12.5ZM20.5 21.5L12.5 16.5V26.5H28.5V16.5L20.5 21.5ZM20.5 19.5L28.5 14.5H12.5L20.5 19.5ZM12.5 16.5V14.5V26.5V16.5Z",
    fill: "#062A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.5cee005e94abf7cc8f2f5bd45dac6978.svg";
export { ForwardRef as ReactComponent };